module.exports = __webpack_public_path__ + "img/icon_ticket_white.d57eacc9.svg";